/**
 * Adresa na koju može da stigne kod: lokalni deo, „@“ i domen sa bar jednom tačkom (ista pravila kao server,
 * EmailFormat.IsMailbox). `administrator@walter` je korisničko ime, ne eMail — prijavljuje se bez koda.
 */
const mailbox = /^[^@\s]+@(?:[\p{L}\p{N}](?:[\p{L}\p{N}-]*[\p{L}\p{N}])?\.)+(?:\p{L}{2,}|xn--[a-z0-9-]+)$/iu;

export function isMailbox(value: string | null | undefined): boolean {
  return !!value && mailbox.test(value.trim());
}
